import script from "./LitigationList.vue?vue&type=script&setup=true&lang=ts"
export * from "./LitigationList.vue?vue&type=script&setup=true&lang=ts"

import "./LitigationList.vue?vue&type=style&index=0&id=7c501ff7&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7c501ff7"]])

export default __exports__